function Title(props) {
  document.title = props.name + ' - ' + process.env.REACT_APP_PROJECT;
}

export default Title;